import { createFileRoute } from "@tanstack/react-router";

import { Metrics } from "~/components/feature/metrics";

export const Route = createFileRoute("/_app/dashboard/metrics")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Metrics />;
}
